import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { reportActions } from '../../../store/reportStore'
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import Paging from '../../common/pagingComponent';
import RelationLink from '../relations/relationLink';

class RelationCRSRSubSection extends React.Component {
    state = {
        historyExpanded: false,
        expandMap: {},
        shouldExpandMap: {},
        page: 1,
        loadingTotal: false
    };
    dataRefMap = {};

    get section() {
        var section = this.props.sections.find(o => o.id === this.props.sectionId)
        return section.subsections.find(q => q.id === this.props.subsectionId) || section;
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId || this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated)
            this.setState({ isHistoryExpandedTouched: false });

        const data = this.section.data;

        if (data) {

            var prevActual = null;
            var prevHistorical = null;
            var prevAddresses = null;

            if (this.prevProps) {
                const prevSection = this.prevProps.sections.find(o => o.id === this.prevProps.sectionId);
                if (prevSection) {
                    var prevSubsection = prevSection.subsections.find(q => q.id === this.prevProps.subsectionId);
                    if (prevSubsection) {
                        var prevData = prevSubsection.data;
                        if (prevData) {
                            prevActual = prevData.relationsActual;
                            prevHistorical = prevData.relationsHistorical;
                            prevAddresses = prevData.addresses;
                        }
                    }
                }
            }

            // run resize only if needed
            if (((prevActual === null || prevActual === undefined) && (data.relationsActual !== null && data.relationsActual !== undefined)) ||
                ((prevHistorical === null || prevHistorical === undefined) && (data.relationsHistorical !== null && data.relationsHistorical !== undefined)) ||
                ((prevAddresses === null || prevAddresses === undefined) && (data.addresses !== null && data.addresses !== undefined)) ||
                ((prevActual || []).length !== (data.relationsActual || []).length) || ((prevHistorical || []).length !== (data.relationsHistorical || []).length) ||
                ((prevAddresses || []).length !== (data.addresses || []).length) ||
                prevState.historyExpanded !== this.state.historyExpanded) {
                this._debounce = window.setTimeout(() => this.updateSize(), 250);
            }
        }
    }

    componentDidMount() {
        this.test = window.addEventListener('resize', this.onResize, false)
        this.updateSize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize, false)
    }

    updateSize = () => {
        this._debounce = undefined;
        if (this.dataRefMap === null || this.dataRefMap === undefined || Object.keys(this.dataRefMap).length === 0) {
            return;
        }
        let shouldExpandMap = { ...this.state.shouldExpandMap };
        let runSetState = false;
        const keys = Object.keys(this.dataRefMap);
        for (let idx = 0; idx < keys.length; idx++) {
            const se = this.dataRefMap[keys[idx]].offsetWidth < this.dataRefMap[keys[idx]].scrollWidth;
            if (shouldExpandMap[keys[idx]] !== se && !this.state.expandMap[keys[idx]]) {
                shouldExpandMap[keys[idx]] = se;
                runSetState = true;
            }
        }
        if (runSetState) {
            this.setState({ shouldExpandMap });
        }
    }

    onResize = e => {
        if (this._debounce !== null && this._debounce !== undefined) {
            window.clearTimeout(this._debounce);
        }
        this._debounce = window.setTimeout(() => this.updateSize(), 250);
    }

    render() {
        if (this.section.name === undefined || this.section.name === null)
            return null;

        const { data, loadingMoreData, isLimited } = this.section;
        if (isNullOrUndefined(data))
            return null;

        var totalCount = 0;
        if (this.props.subsectionId)
            totalCount = this.props.getParentSection([this.props.sectionId, this.props.subsectionId]).data.sectionCounts.find(f => f.sectionId === this.props.subsectionData.type).count;

        const max = totalCount > this.pageSize * this.state.page ? this.pageSize * this.state.page : totalCount;

        return (
            <>
                <OldStyleTableWithHistory offsetLeft={false} isLimited={isLimited} classNames='related-addresses'
                    head={() => this.renderHead()} tableColumns={8} onHistoryToggle={this.onHistoryToggle} stripped
                    actualData={data.relationsActual} actualRow={(r) => this.renderRelationRow(r, false)}
                    historyData={data.relationsHistorical} historyRow={(r) => this.renderRelationRow(r, true)}
                    resolveExpanded={this.props.resolveExpanded}
                />
                {isLimited && totalCount > max && this.renderMoreLinks(totalCount, loadingMoreData)}
                {!isLimited && totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                {this.state.loadingTotal && <div style={{ width: "100%", fontSize: "0.1em" }} className="search-progress searching" />}
            </>
        )
    }

    onHistoryToggle = (historyExpanded) => {
        this.setState({ historyExpanded })
    }

    renderHead = () => {
        return (
            <thead className="relations-header">
                <tr>
                    <th className="col-1" />
                    <th className="col-2"><Translate id="Report.Relations.EntityName" /></th>
                    <th className="col-3"><Translate id="Report.Relations.EntityIdentification" /></th>
                    <th className="col-4"><Translate id="Report.Relations.Position" /></th>
                    <th className="col-5"><Translate id="Report.Relations.ShareDeposit" /></th>
                    {/* <th className="col-6"><Translate id="Report.Relations.WarningInfo" /></th> */}
                    <th className="col-7" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidFrom" /></th>
                    <th className="col-8" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidTo" /></th>
                    <th className="col-9"><Translate id="Report.Relations.Country" /></th>
                </tr>
            </thead>
        );
    }

    renderRelationRow = (r, isHistory) => {
        return (
            <tr key={r.id} className={classnames('relations-row', 'colorize', { 'old-style-table-report-history-row': isHistory })}>
                <td className="col-1"></td>
                <td className="col-2"><RelationLink type={"search"} wrap entityName={r.fullName} query={this.removeTitleFromFullName(r.fullName)} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-3">{this.renderEntityIdentification(r)}</td>
                <td className="col-4" colSpan="1">{r.position}</td>
                <td className="col-5" style={{ display: "table-cell", overflowWrap: 'break-word', wordWrap: 'break-word' }}>{this.renderOwnerShare(r)}</td>
                {/* <td className="col-6">{this.renderWarnings(r.warnings)}</td> */}
                <td className="col-7" style={{ textAlign: 'right' }}>{r.startDateFormated}</td>
                <td className="col-8" style={{ textAlign: 'right' }}>{r.endDateFormated}</td>
                <td className="col-9" title={r.country}>{r.countryCode}</td>
            </tr>
        );
    }

    removeTitleFromFullName = (fullName) => {
        var arr = fullName.split(' ');
        if (arr[0].endsWith('.')) {
            arr.shift();
            return arr.join(' ');
        }
        return fullName;
    }

    renderEntityIdentification = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.birthDateFormated !== undefined && entity.birthDateFormated !== null)
            return entity.birthDateFormated;
        else
            return entity.companyId;
    }

    renderOwnerShare = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.share === null && entity.depositValue === null)
            return null;

        return (
            <React.Fragment>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.shareFormated}<span className="l-padded r-padded">/</span></span>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.depositValueFormated}&nbsp;</span>
                <span>
                    {entity.currencyUnit === 1000 && <><Translate id="Report.Common.CurrencyThousands" /><span className="l-padded" /></>}
                    {entity.currency}
                </span>
            </React.Fragment>
        );
    }

    getMore = () => {
        this.props.fetchMoreData(
            this.props.subsectionId ? [this.props.sectionId, this.props.subsectionId] : [this.props.sectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: this.props.subsectionData.type, withHistory: true },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            this.props.subsectionId ? [this.props.sectionId, this.props.subsectionId] : [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: this.props.subsectionId ? this.props.subsectionData.type : 'NRSA', withHistory: true },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    renderMoreLinks = (totalCount, isLoading) => {
        return (
            <>
                <div>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />
                        <>&nbsp;({totalCount})</>
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%", paddingBottom: '0', paddingTop: '0' }} className="search-progress searching"></div>}
            </>
        )
    }

    concatData = (_hint, oldData, newData) => {
        if (!isNullOrUndefined(oldData.relationsActual))
            oldData.relationsActual = oldData.relationsActual.concat(newData.relationsActual);
        if (!isNullOrUndefined(oldData.relationsHistorical))
            oldData.relationsHistorical = oldData.relationsHistorical.concat(newData.relationsHistorical);
        return oldData;
    }

    replaceData = (_hint, _oldData, data) => data;

    showLess = (id) => {
        let expandMap = { ...this.state.expandMap };
        expandMap[id] = !expandMap[id];
        this.setState({ expandMap });
    }
}

export default withLocalize(withRouter(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationCRSRSubSection)));